import { CONTENT_ROOT_ID } from '@constants';

export const queryAppContentArea = () => {
	return document.getElementById(CONTENT_ROOT_ID);
};

export const queryIframeContent = () => {
	const content = queryAppContentArea();

	if (!content || !content.querySelector('iframe')) {
		return null;
	}

	return content.querySelector('iframe').contentDocument;
};

export const queryIframeWindow = () => {
	const contentDocument = queryIframeContent();

	if (!contentDocument) {
		return null;
	}

	return contentDocument.defaultView;
};
